import styled from 'styled-components'

export const Container = styled.li`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

interface MainProps {
  positiveResult: boolean
  isOpen: boolean
}

export const Main = styled.label<MainProps>`
  position: relative;
  width: 100%;
  height: 50px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0 1rem;

  border-radius: 5px;
  border-left: ${({ positiveResult }) => (positiveResult ? '6px solid #f73737' : 'none')};
  background: ${({ isOpen, theme }) => (isOpen ? theme.colors.colorf7f9fc : theme.zds.colors.neutral1000)};
  cursor: pointer;

  &:hover {
    background: ${props => props.theme.colors.colorf7f9fc};
  }
  &:focus-visible {
    outline: none;
    box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.color378ff7};
  }
`

export const Title = styled.span`
  position: relative;
  width: 100%;

  font-family: 'Inter';
  text-align: left;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: ${props => props.theme.colors.color292929};
`

export const ExpandableContentItem = styled.div`
  position: relative;
  width: 100%;
  padding-left: 6px;
  margin-top: 8px;
`

export const ExpandableItem = styled.span`
  font-family: 'Inter';
  font-size: 12px;
  line-height: 22px;
  color: ${props => props.theme.colors.color6b7786};
`

export const Result = styled.strong`
  font-weight: 700;
`
